// extracted by mini-css-extract-plugin
export default {"containerDashboardP":"TabelaEPorosive_containerDashboardP__jc2+V","DataPerFiltrim":"TabelaEPorosive_DataPerFiltrim__acuIa"};